import { Duration } from 'luxon';

export function formatHour(hour: number): string {
  const d = Duration.fromObject({ hours: hour });
  return (hour >= 24 ? d.minus({ minutes: 1 }) : d).toFormat('hh:mm');
}
